module.exports = __webpack_public_path__ + "img/ai-models.668a0348.jpg";